document.addEventListener('DOMContentLoaded', function() {

  let news = document.querySelector('.news');
  if (news) {
      setTimeout(() => {
        console.log("init slider");
        let slNav = news.querySelector('.sl-nav');
        let slPag = news.querySelector('.swiper-pagination');
        let slider = new Swiper('.news .swiper-container', {
            slidesPerView: 'auto',
            navigation: {
                prevEl: slNav.querySelector('.sl-nav__btn--prev'),
                nextEl: slNav.querySelector('.sl-nav__btn--next'),
            },
            pagination: {
              el: slPag,
              clickable: true,
          },
        });
      }, 1000);
  }

});